import API from '@/services/endpoint'
import { FETCH_HOME_TEXT_CONTENT} from "../../mutation-types";

/**
 * API Get Request to fetch the content
 * @param {function} commit - The vuex commit function
 * @param {object} state - The vuex state object
 * @return {object[]} A array of content
 */
export async function fetchHomeTextContent({commit, state}) {
  const { url } = state;
  let responseObj = await API.get(url);
  let { data: { message: { contents } } } = responseObj;
  commit(FETCH_HOME_TEXT_CONTENT, contents)
}
